import { Tag } from 'antd'
import { FunctionComponent } from 'react'
import { useIntl } from '@/i18n/hooks/use-intl'
import type { Optional } from '@/types/optional'
import { postTypeSchema } from '@/types/schema/post-type'
import { PlatformShortcode } from '@/utils/convert-platform'

interface PostTypeTagProps {
  isCustomPlatform: boolean
  platform?: PlatformShortcode | string
  isCustomPostType: boolean
  postType: string
}

const PostTypeTag: FunctionComponent<PostTypeTagProps> = ({
  isCustomPlatform,
  platform,
  isCustomPostType,
  postType,
}) => {
  const { formatMessage } = useIntl()

  const text = ((): Optional<string> => {
    if (isCustomPlatform) {
      return `${platform}-${postType}`
    }

    if (isCustomPostType) {
      return postType
    }

    switch (postType) {
      case postTypeSchema.enum.text:
      case postTypeSchema.enum.post:
      case postTypeSchema.enum.image:
        return formatMessage({ id: 'general:cooperation_item_type_post' })
      case postTypeSchema.enum.video:
        return formatMessage({ id: 'general:cooperation_item_type_video' })
      case postTypeSchema.enum.live:
        return formatMessage({ id: 'general:cooperation_item_type_live' })
      case postTypeSchema.enum.short:
        switch (platform) {
          case PlatformShortcode.Facebook:
          case PlatformShortcode.Instagram:
            return formatMessage({ id: 'general:cooperation_item_type_reels' })
          case PlatformShortcode.YouTube:
            return formatMessage({ id: 'general:cooperation_item_type_short' })
          default:
            return undefined
        }
      case postTypeSchema.enum.story:
        return formatMessage({ id: 'general:cooperation_item_type_story' })
      case postTypeSchema.enum.ad_authorization:
        return formatMessage({
          id: 'general:cooperation_item_type_ad_authorization',
        })
      case postTypeSchema.enum.material_authorization:
        return formatMessage({
          id: 'general:cooperation_item_type_material_authorization',
        })
      default:
        return undefined
    }
  })()

  if (!text) {
    return null
  }

  return <Tag color='blue'>{text}</Tag>
}

export default PostTypeTag
